// src/components/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Badge, Box, Divider } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import BuildIcon from '@mui/icons-material/Build';
import { useAppContext } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { useThemeContext } from '../context/ThemeContext';

const drawerWidth = 240;

function Sidebar() {
  const { currentUser } = useAuth();
  const { importCount, exportCount, processingExportCount, canRecoveryCount } = useAppContext();
  const { theme, toggleTheme } = useThemeContext();
  const location = useLocation();

  const allMenuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard', permission: 'viewDashboard' },
    { text: 'Hàng Nhập', icon: <ArrowDownwardIcon />, path: '/hang-nhap', badge: importCount, permission: 'viewImports' },
    { text: 'Hàng Xuất', icon: <ArrowUpwardIcon />, path: '/hang-xuat', badge: exportCount, permission: 'viewExports' },
    { text: 'Tồn Kho', icon: <InventoryIcon />, path: '/ton-kho', permission: 'viewInventory' },
    { text: 'Báo cáo', icon: <AssessmentIcon />, path: '/bao-cao', permission: 'viewReports' },
    { text: 'Công nợ Nhập', icon: <AccountBalanceWalletIcon />, path: '/cong-no-nhap', permission: 'viewPayable' },
    { text: 'Công nợ Xuất', icon: <AccountBalanceWalletIcon />, path: '/cong-no-xuat', permission: 'viewReceivable' },
    { text: 'Theo dõi Vỏ can', icon: <InvertColorsIcon />, path: '/theo-doi-vo-can', badge: canRecoveryCount, permission: 'viewCanTracking' },
    { text: 'Chỉnh sửa', icon: <BuildIcon />, path: '/chinh-sua', permission: 'viewEditPage' },
    { text: 'Nhân Viên', icon: <PeopleIcon />, path: '/nhan-vien', permission: 'viewPersonnel' },
    { text: 'Theo dõi đơn hàng', icon: <TrackChangesIcon />, path: '/theo-doi-don-hang', badge: processingExportCount, permission: 'viewOrderTracking' },
  ];
  
  const isSuperUser = currentUser?.roleNames?.some(name => name.toLowerCase() === 'admin') || currentUser?.permissions?.full_access;

  const visibleMenuItems = allMenuItems.filter(item => 
    isSuperUser || currentUser?.permissions?.[item.permission]
  );

  return (
    <Drawer
      sx={{ width: drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' } }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar />
      <List sx={{ flexGrow: 1 }}>
        {visibleMenuItems.map((item) => (
          <ListItem key={item.text} disablePadding component={Link} to={item.path} sx={{ color: 'inherit', textDecoration: 'none' }}>
            <ListItemButton selected={location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText 
                primary={
                  item.badge > 0 ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      {item.text}
                      <Badge badgeContent={item.badge} color="error" />
                    </Box>
                  ) : (
                    item.text
                  )
                } 
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
          <ListItem disablePadding>
              <ListItemButton onClick={toggleTheme}>
                  <ListItemIcon>
                      {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                  </ListItemIcon>
                  <ListItemText primary={`Chế độ ${theme.palette.mode === 'dark' ? 'Sáng' : 'Tối'}`} />
              </ListItemButton>
          </ListItem>
      </List>
    </Drawer>
  );
}

export default Sidebar;
